import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useRecoilState } from 'recoil';
import { userData } from '../recoil/atom/userData';
import { getUserService } from '../service/userService';
import { registerWhatsappAccount } from '../service/whatsappRegistrationService';

export const useWhatsappOnboarding = () => {
  const [user, setUser] = useRecoilState(userData);
  const [isLoading, setIsLoading] = useState(false);
  const [fbLoaded, setFbLoaded] = useState(false);
  const [signupError, setSignupError] = useState('');
  const [response, setResponse] = useState();

  useEffect(() => {
    if (response) {
      registerWhatsapp(response);
    }
  }, [response]);

  useEffect(() => {
    // Load Facebook SDK
    const loadFacebookSDK = () => {
      if (window.FB) {
        // FB already exists, but make sure it's initialized
        if (window.FB.getAuthResponse) {
          setFbLoaded(true);
          return;
        }
      }

      window.fbAsyncInit = function () {
        window.FB.init({
          appId: process.env.REACT_APP_META_APP_ID,
          cookie: true,
          xfbml: true,
          version: 'v23.0',
        });

        // Wait for FB.init to complete before setting fbLoaded to true
        window.FB.AppEvents.logPageView();
        setFbLoaded(true);
      };

      // Load the SDK asynchronously
      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.crossOrigin = 'anonymous';
      script.src = 'https://connect.facebook.net/en_US/sdk.js';
      document.head.appendChild(script);
    };

    loadFacebookSDK();
  }, []);

  useEffect(() => {
    const handleEvent = (event) => {
      if (!event.origin.endsWith('facebook.com')) return;
      try {
        if (typeof event.data === 'string' && event.data.includes('waba_id')) {
          const data = JSON.parse(event.data);
          if (data.type === 'WA_EMBEDDED_SIGNUP') {
            const payload = data.data;
            setResponse(payload);
          }
          if (data.event === 'CANCEL') {
            setSignupError(data?.error_message ?? 'Cancelled Registration!');
          }
        }
      } catch {
        setSignupError('Something went wrong. Please try again!');
        // your code goes here
        // setSignupError(event?.data?.error_message ?? 'Cancelled Registration!');
      }
    };
    // Session logging message event listener
    window.addEventListener('message', (event) => handleEvent(event));

    return () => {
      console.log('removing message listener');
      window.removeEventListener('message', handleEvent);
    };
  }, []);

  const handleEmbeddedSignup = () => {
    try {
      if (!fbLoaded || !window.FB || typeof window.FB.login !== 'function') {
        console.error('Facebook SDK not loaded');
        return;
      }

      setIsLoading(true);

      window.FB.login(
        function (response) {
          setIsLoading(false);
          if (response.authResponse.code) {
          } else {
            console.log('User cancelled login or did not fully authorize.');
            setSignupError(
              'Cancelled login or Something went wrong. Please try again!'
            );
          }
        },
        {
          config_id: process.env.REACT_APP_META_CONFIG_ID,
          response_type: 'code',
          override_default_response_type: true,
          extras: {
            feature: 'whatsapp_embedded_signup',
            sessionInfoVersion: 2,
          },
        }
      );
    } catch (error) {
      setIsLoading(false);
    }
  };

  const registerWhatsapp = async (payload) => {
    try {
      setIsLoading(true)
      const response = await registerWhatsappAccount(payload);
      toast.success(response?.data?.message ?? 'Registration Started!');
    } catch (error) {
      toast.error('Failed to register. Please contact admin');
    } finally {
      const userResponse = await getUserService();
      setUser(userResponse.data);
      setIsLoading(false)
    }
  };

  return {
    user,
    isLoading,
    fbLoaded,
    handleEmbeddedSignup,
    signupError,
  };
};
